import camelcase from 'camelcase';

import types from '@constants/action-types';
import { ADD_DATA } from '@constants/general';
import { reducerFactory } from '@factories';
import { removeDuplicates } from '@helpers/array';
import { history } from '@routes/history';

export const initialState = {
  isLoading: true,
  isItemDeleting: [],
  error: null,
  results: [],
  files: [],
  filesMap: {
    calculations: [],
    proofPayment: [],
    vatReturn: [],
    supportingDocument: [],
    postConversion: [],
  },
  selected: {},
  spreadsheets: [],
};

export default reducerFactory(initialState, {
  [types.RESET_SAVED_FILING_PERIOD]: () => ({ ...initialState, files: [] }),
  [types.RESET_FILES]: state => ({ ...state, isLoading: false, files: [] }),
  [types.GET_SAVED_FILING_PERIOD_FILE_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_SAVED_FILING_PERIOD_FILE_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    files: [...state.files.filter(f => f.id !== response.response.id), response.response],
    filesMap: {
      ...state.filesMap,
      [camelcase(response.response.category)]: [
        ...state.filesMap[camelcase(response.response.category)],
        response.response,
      ],
    },
  }),
  [types.GET_SAVED_FILING_PERIOD_FILE_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.CREATE_SAVED_FILING_PERIOD_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.CREATE_SAVED_FILING_PERIOD_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    files: [...state.files, response.response],
  }),
  [types.CREATE_SAVED_FILING_PERIOD_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.LIST_SAVED_FILING_PERIOD_FILES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
    results: [],
  }),
  [types.LIST_SAVED_FILING_PERIOD_FILES_SUCCESS]: (state, { response }) => {
    const files = history.location.pathname.endsWith(ADD_DATA)
      ? response.response.files
      : removeDuplicates([...state.files, ...response.response.files], 'id');
    return {
      ...state,
      isLoading: false,
      files,
      filesMap: {
        ...state.filesMap,
        [response.response.category]: response.response.files,
      },
    };
  },
  [types.LIST_SAVED_FILING_PERIOD_FILES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.DELETE_SAVED_FILING_PERIOD_FILE_REQUEST]: (state, { payload }) => ({
    ...state,
    isItemDeleting: [...state.isItemDeleting, payload.id],
    error: null,
  }),
  [types.DELETE_SAVED_FILING_PERIOD_FILE_SUCCESS]: (state, { response }) => ({
    ...state,
    isItemDeleting: state.isItemDeleting.filter(item => item !== response.id),
    files: state.files.filter(({ id }) => id !== response.id),
    filesMap: {
      ...state.filesMap,
      [camelcase(response.category)]: state.filesMap[camelcase(response.category)].filter(
        ({ id }) => id !== response.id
      ),
    },
  }),
  [types.DELETE_SAVED_FILING_PERIOD_FILE_FAILURE]: (state, { response }) => ({
    ...state,
    isItemDeleting: state.isItemDeleting.filter(item => item !== response.id),
  }),
  [types.GET_SAVED_FILING_PERIOD_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_SAVED_FILING_PERIOD_BY_ID_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    selected: response.savedFilingPeriod,
  }),
  [types.GET_SAVED_FILING_PERIOD_BY_ID_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.LIST_SAVED_FILING_PERIOD_JSON_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.LIST_SAVED_FILING_PERIOD_JSON_SUCCESS]: (state, { payload: { results } }) => ({
    ...state,
    isLoading: false,
    spreadsheets: results,
  }),
  [types.LIST_SAVED_FILING_PERIOD_JSON_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.DELETE_SAVED_FILING_PERIOD_JSON_REQUEST]: (state, { payload }) => ({
    ...state,
    isItemDeleting: [...state.isItemDeleting, payload.spreadsheetId],
    error: null,
  }),
  [types.DELETE_SAVED_FILING_PERIOD_JSON_SUCCESS]: (state, { response }) => ({
    ...state,
    spreadsheets: state.spreadsheets.filter(result => result.id !== response.spreadsheetId),
    isItemDeleting: state.isItemDeleting.filter(item => item !== response.spreadsheetId),
  }),
  [types.DELETE_SAVED_FILING_PERIOD_JSON_FAILURE]: (state, { response }) => ({
    ...state,
    isItemDeleting: state.isItemDeleting.filter(item => item !== response.spreadsheetId),
  }),
  [types.UPDATE_SAVED_FILING_PERIOD_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.UPDATE_SAVED_FILING_PERIOD_BY_ID_SUCCESS]: (state, { response }) => ({
    ...state,
    selected: response.savedFilingPeriod,
    isLoading: false,
  }),
  [types.UPDATE_SAVED_FILING_PERIOD_BY_ID_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
});
